import React, { Component, PropTypes } from 'react';
import { hashHistory, Link } from 'react-router'
import { inject, observer } from "mobx-react/index";
import { autorun, reaction, toJS } from 'mobx';
import LeafletMap from '../LeafletMap';
import { getCenter } from '../Map/getCenterLatLng';
import Spinner from '../Spinner';
// import { withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
// import withScriptjs from 'react-google-maps/lib/withScriptjs';
import DataTable from '../DataTable';
import { marker, polyline } from 'leaflet';
import GoogleMapReact from 'google-map-react';
import { tripApi, googleDistanceApi, tabular } from '../../actions/api';
import { duration } from 'moment';
import { getFromLocalStorage } from '../../libs/localStorage';



@inject('ticketStatusStore', 'ticketActionStore', 'ticketReasonStore', 'ticketStore', 'userStore', 'stationStore', 'tripStore', 'workOrderStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore')
@observer
class TripMapTicketId extends React.Component {

  state = {
    markers: [],
    markerIcons: [],
    mapCenter: null,
    selectedMarker: null,
    showPopUp: false,
    clickedMarker: null,
    clickCounts: {},
    nextCount: 1,
    clickedMarkers: [],
    distances: {},
    map: null,
    maps: null,
    tableData: [],
    hasCalculatedDistance: false,
    insertData: true,
    isPreviousData: false,
    clickTimeOut: null,
    polylines: [],
    keysRemove: [],
    extraDuration: '',
    tripByTripIdData:[]
  };

  dispose;

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
  };

  componentDidMount() {
    const { tripStore, stationStore, params: id, ticketStore } = this.props;

    this.disposer = autorun(() => {
      const { station_id, duration, previous_stationId } = tripStore.stationData;
      const handleClickData = stationStore.findById(station_id)
      this.setState({ extraDuration: duration })
      if (!!handleClickData) this.handleSingleClick(station_id, handleClickData.latitude, handleClickData.longitude, handleClickData.name, previous_stationId);

    });



  }

  async componentWillMount() {
    const { params: { id }, workOrderStore, ticketStore } = this.props
    // this.dispose = reaction(
    //   () => ticketStore.items.map(ticket => ticket.archived), 
    //   archivedValues => {
    //     console.log("Ticket archive status changed:", archivedValues);
    //     this.forceUpdate(); // Trigger re-render
    //   }
    // );

    // if (getFromLocalStorage('isArchived') == true) {
    //   console.log(getFromLocalStorage('isArchived'), '111111111111111111111')

    const data = await tripApi.fetchTripByTripId(id)
    this.setState({tripByTripIdData:data})
    const distanceData = await tripApi.fetchStationRouteByTripId(id)
    let uniqueData

    if (data && data.length > 0) {

      const newDataWorkOrder = data.filter((item) => {
        const matchingWorkOrder = workOrderStore.items.find((i) => i.id == item.work_order_id)
        return matchingWorkOrder && !matchingWorkOrder.archived
      })


      const newDataTicket = data.filter((item) => {
        const matchingTicket = ticketStore.items.find((i) => i.id == item.ticket_id)
        return matchingTicket && !matchingTicket.archived
      })


       uniqueData = [...newDataWorkOrder, ...newDataTicket].reduce((acc, item) => {
        if (!acc.some(existingItem => existingItem.station_id === item.station_id)) {
          acc.push(item);
        }
        return acc;
      }, []).sort((a, b) => a.seq - b.seq);
      this.setState({ clickedMarkers: uniqueData, isPreviousData: true })
    }


    if (Array.isArray(uniqueData)) {
      const formattedData = {};
      const stationIds = new Set(uniqueData.map(item => item.station_id));
      distanceData.forEach(item => {
        const { start_station_id, end_station_id, distance, duration, polyline } = item;
        if (stationIds.has(start_station_id) && stationIds.has(end_station_id)) {
          if (distanceData) {
            distanceData.forEach(item => {
              const key = `${item.start_station_id}-${item.end_station_id}`;
              formattedData[key] = {
                distance: item.distance,
                duration: item.duration,
                polyline: item.polyline
              };
            }); 
          }

          this.setState({ distances: formattedData }, this.getTableData)
        }
      });
    }



  }

  componentDidUpdate(prevProps, prevState) {
    const { ticketStore } = this.props
    const { assigned_to_all } = ticketStore
    const { clickedMarkers, isPreviousData, polylines, keysRemove, distances } = this.state
    const { station_id, duration } = this.props.tripStore.stationData;

    if (prevState.keysRemove !== keysRemove) {
      keysRemove.forEach((key) => {
        if (polylines[key]) {
          polylines[key].setMap(null);
          delete polylines[key];
        }
      });
    }

    if (prevState.distances !== this.state.distances) {
      Object.entries(this.state.distances).forEach(([key, value]) => {
        if (!value || !this.state.maps) return
        if (!this.state.polylines[key]) {
          const decodedPath = this.state.maps.geometry.encoding.decodePath(value.polyline);
          const polylineOptions = {
            path: decodedPath,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 3,
          };

          const routePolyline = new this.state.maps.Polyline(polylineOptions);
          this.state.polylines[key] = routePolyline;
        }
        const polyline = this.state.polylines[key];
        polyline.setMap(this.state.map);

      });
    }

    if (!this.state.hasCalculatedDistance && isPreviousData == true) {
      const maxValue = Math.max(...clickedMarkers.map((item) => item.seq));
      const counts = clickedMarkers.reduce((acc, item) => {
        acc[item.station_id] = item.seq
        return acc
      }, {})

      // this.calculateDistance2();
      this.setState({ hasCalculatedDistance: true, insertData: false, clickCounts: counts, nextCount: maxValue + 1 });
    }
  }

  componentWillUnmount() {
    const { tripStore } = this.props
    tripStore.updateStationData({
      station_id: '',
      duration: '',
      prevStationId: ''
    });
    if (this.disposer) this.disposer();
  }



  resetMarkers = (ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all, userStore) => {
    const markers = ticketStatusStore.items.length > 0 && ticketReasonStore.items.length > 0 && ticketActionStore.items.length > 0
      ? ticketStore.getMarkers()
      : [];
    const markerIcons = this.filterMarkerByShow(markers).map(marker => (
      Object.assign({}, {
        id: 'ticket_marker-' + marker.tickets[0].id,
        station_id: marker.station_id,
        position: [marker.latitude, marker.longitude],
        icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
        iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
        // popupBox: this.getPopupBox(marker)
      })
    ));
    let mapCenter = getCenter(markers);
    this.setState({ markers, mapCenter, markerIcons });
  }

  getFilteredMarkerIcons = markers => markers.reduce((acc, marker) => {
    if (!marker.latitude || !marker.longitude) return acc;
    const { ticketStore } = this.props;

    if (!!ticketStore.viewBy && !!ticketStore.show) {
      switch (+ticketStore.viewBy) {
        case 1: if (!marker.tickets.find(item => item.status_id === +ticketStore.show)) return acc; else break;
        case 2: if (!marker.tickets.find(item => item.reason_id === +ticketStore.show)) return acc; else break;
        case 3: if (!marker.tickets.find(item => item.action_id === +ticketStore.show)) return acc; else break;
        case 4: if (!marker.tickets.find(item => +item.assigned_to === +ticketStore.show)) return acc; else break;
        case 5: if (!marker.tickets.find(item => +item.user_id === +ticketStore.show)) return acc; else break;
        default: break;
      }
    }

    acc.push({
      id: 'ticket_marker-' + marker.tickets[0].id,
      station_id: marker.station_id,
      position: [marker.latitude, marker.longitude],
      latitude: marker.latitude, longitude: marker.longitude,
      icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
      iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `
    });
    return acc;
  }, []);

  getFilteredMarkerIcons2 = markers => markers.reduce((acc, marker) => {
    if (!marker.latitude || !marker.longitude) return acc;
    const { workOrderStore } = this.props;

    if (!!workOrderStore.viewBy && !!workOrderStore.show) {
      switch (+workOrderStore.viewBy) {
        case 1: if (!marker.work_orders.find(item => +item.status_id === +workOrderStore.show)) return acc; else break;
        case 2: if (!marker.work_orders.find(item => +item.priority_id === +workOrderStore.show)) return acc; else break;
        case 3: if (!marker.work_orders.find(item => +item.maintenance_type === +workOrderStore.show)) return acc; else break;
        case 4: if (!marker.work_orders.find(item => +item.assigned_to === +workOrderStore.show)) return acc; else break;
        default: break;
      }
    }

    acc.push({
      id: 'work_order_marker-' + marker.work_orders[0].id,
      station_id: marker.station_id,
      color: marker.color,
      position: [marker.latitude, marker.longitude],
      latitude: marker.latitude, longitude: marker.longitude,
      icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
      iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `
    });
    return acc;
  }, []);

  handleHover = (stationId) => {
    this.setState({ selectedMarker: stationId })
  }

  handleSingleClick = (stationId, lat, lng, name, previous_stationId) => {
    const { params: { id } } = this.props
    let isLast
    if (this.state.clickTimeOut) clearTimeout(this.state.clickTimeOut);

    this.state.clickTimeOut = setTimeout(() => {
      if (!stationId) return;

      this.setState(
        (prevState) => {
          const { clickCounts, nextCount, clickedMarkers } = prevState;
          if (clickCounts[stationId]) return null;
          const newClickCounts = { ...clickCounts, [stationId]: nextCount };

          const newMarker = {
            station_id: Number(stationId),
            latitude: lat,
            longitude: lng,
            name,
            trip_id: id,
            extraDuration: this.state.extraDuration
          };

          const previousIndex = clickedMarkers.findIndex(
            (marker) => marker.station_id === Number(previous_stationId)
          );

          const lastIndex = clickedMarkers.length - 1
          isLast = previousIndex === lastIndex

          let newClickedMarkers;
          if (previousIndex !== -1) {
            newClickedMarkers = [
              ...clickedMarkers.slice(0, previousIndex + 1),
              newMarker,
              ...clickedMarkers.slice(previousIndex + 1),
            ];
          } else {
            newClickedMarkers = [...clickedMarkers, newMarker];
          }
          const count = clickedMarkers.length + 1
          return {
            clickCounts: newClickCounts,
            nextCount: newClickedMarkers.length + 1,
            clickedMarkers: newClickedMarkers,
          };
        },
        previous_stationId && !isLast ? this.calculateDistance2 : this.calculateDistance
      );
    }, 300);
    this.setState({ insertData: true })
  };

  handleDelete = async (stationId) => {
    const { tripStore, params: { id } } = this.props
    await this.handleDoubleClick(stationId, 'onDelete')
    await tripApi.deleteTripOrderByStationId({ station_id: stationId });
    await tripApi.deleteRoutesByStationId({ station_id: stationId, trip_id: id });
    tripStore.updateStationData({
      station_id: '',
      duration: '',
      prevStationId: ''
    });
  };

  handleDoubleClick = async (stationId, value) => {
    if (this.state.clickTimeOut) clearTimeout(this.state.clickTimeOut);

    this.setState((prevState) => {
      const { clickCounts, clickedMarkers, distances, polylines, nextCount, maps, keysRemove } = prevState;
      if (clickCounts[stationId]) {
        const updatedClickCounts = { ...clickCounts };
        delete updatedClickCounts[stationId];
        const updatedClickedMarkers = clickedMarkers.filter(
          (marker) => marker.station_id != stationId
        );

        const polylineKeysToRemove = Object.keys(distances).filter((key) =>
          key.includes(stationId)
        );
        const updatedDistances = { ...distances };

        polylineKeysToRemove.forEach((key) => {
          delete updatedDistances[key];
        });

        return {
          clickCounts: updatedClickCounts,
          clickedMarkers: updatedClickedMarkers,
          distances: updatedDistances,
          nextCount: nextCount - 1,
          keysRemove: polylineKeysToRemove

        };
      }

      return null;
    }, this.calculateDistance2)


    this.setState({ insertData: true })
  };

  getTableData = async () => {
    const { clickedMarkers, distances, extraDuration } = this.state;
    const { params: { id }, tripStore, workOrderStore, ticketStore } = this.props
    let uniqueId = 1;

    const tableData = clickedMarkers.flatMap((
      marker, index) => {
      const workOrder = workOrderStore && workOrderStore.items && workOrderStore.items.reduce((latest, item) => {
        if (item.station &&
          Array.isArray(item.station) &&
          item.station.some(station => station.id == marker.station_id) && item.archived !== true) {
          return !latest || (new Date(item.creation_date) > new Date(latest.creation_date)) ? item : latest
        }
        return latest
      }, null)

      const ticket = ticketStore.items && ticketStore.items.reduce((latest, item) => {
        if (item.station_id == marker.station_id && !item.archived) {
          return !latest || new Date(item.generated_date) > new Date(latest.generated_date) ? item : latest
        }
        return latest
      }, null);

      const nextMarker = clickedMarkers[index + 1];
      if (!nextMarker) {
        return {
          sn: uniqueId++,
          station: marker.name,
          dbEntry: true,
          distance: 'N/A',
          duration: marker.duration || extraDuration || 'N/A',
          station_id: Number(marker.station_id),
          latitude: marker.latitude,
          longitude: marker.longitude,
          name: marker.name,
          trip_id: marker.trip_id,
          extraDuration: marker.duration,
          work_order: workOrder ? <Link to={`/monitoring/work_order/tabular/${workOrder.id || null}/view`}>{workOrder.title || 'View'}</Link> : 'No Work Order',
          work_order_id: workOrder ? workOrder.id : null,
          ticket_id: ticket ? ticket.id : null
        };
      }
      const distanceKey = `${marker.station_id || marker.stationId}-${nextMarker.station_id || nextMarker.stationId}`;
      const distanceInfo = distances[distanceKey] || { distance: 'N/A', duration: 'N/A' };

      const rows = [
        {
          sn: uniqueId++,
          station: marker.name,
          station_id: Number(marker.station_id),
          latitude: marker.latitude,
          longitude: marker.longitude,
          name: marker.name,
          trip_id: marker.trip_id,
          work_order: workOrder ? <Link to={`/monitoring/work_order/tabular/${workOrder.id || null}/view`}>{workOrder.title || 'View'}</Link> : 'No Work Order',
          dbEntry: true,
          duration: marker.duration || extraDuration,
          work_order_id: workOrder ? workOrder.id : null,
          ticket_id: ticket ? ticket.id : null
        }
      ];


      if (nextMarker) {
        rows.push({
          station: `${marker.name} ---> ${nextMarker.name}`,
          distance: distanceInfo.distance,
          duration: distanceInfo.duration,
          station_id: Number(marker.station_id),
          latitude: marker.latitude,
          longitude: marker.longitude,
          name: marker.name,
          trip_id: marker.trip_id,
          dbEntry: false
        });
      }

      return rows;
    })

    const filteredTableTable = tableData.filter((item) => item.dbEntry == true)

    const existingData = this.state.tripByTripIdData
    let uniqueTableData = []
    let toDeleteData = []
    if (existingData.length > 0) {
      uniqueTableData = filteredTableTable.filter(newRow =>
        !existingData.some(existingRow =>
          existingRow.station_id == newRow.station_id &&
          existingRow.seq == newRow.sn
        )
      );

      toDeleteData = existingData.filter(marker => !filteredTableTable.some(clicked => clicked.station_id == marker.station_id));
    } else {
      uniqueTableData = filteredTableTable
    }

    if (toDeleteData && toDeleteData.length) {
      await tripApi.updateArchiveFlag(toDeleteData[0]);
      await tripApi.deleteRoutesByStationId(toDeleteData[0]);
      await tripStore.fetchItems()
    }

    if (this.state.insertData) {
      if (Object.keys(distances).length > 0) {
        const lastKey = Object.keys(distances).pop();
        const lastValue = distances[lastKey];

        const [start_station_id, end_station_id] = lastKey.split("-").map(Number);

        const payload = {
          start_station_id,
          end_station_id,
          distance: lastValue.distance,
          duration: lastValue.duration,
          polyline: lastValue.polyline,
          trip_id: id
        };

        await tripApi.saveStationRoute(payload);

      }


      await tripApi.tripOrder(uniqueTableData);
      await tripStore.fetchItems();
    }


    this.setState({ tableData });
  };

  calculateDistance = async () => {
    const { clickedMarkers, maps, map } = this.state;
    const lastMarker = clickedMarkers[clickedMarkers.length - 1];
    const secondLastMarker = clickedMarkers[clickedMarkers.length - 2];

    if (!secondLastMarker) {
      this.insertData == true
      this.getTableData()
    }
    if (!lastMarker) return
    try {
      const response = await tripApi.create({
        origin: `${secondLastMarker.latitude},${secondLastMarker.longitude}`,
        destination: `${lastMarker.latitude},${lastMarker.longitude}`,
      });

      const polylineKey = `${secondLastMarker.station_id}-${lastMarker.station_id}`;
      if (response.status === 'OK') {
        const directions = response.routes[0];

        this.setState((prevState) => ({
          distances: {
            ...prevState.distances,
            [polylineKey]: {
              distance: directions.legs[0].distance.text,
              duration: directions.legs[0].duration.text,
              polyline: directions.overview_polyline.points,
            },
          }
        }))
        this.getTableData()
      } else {
        this.setState((prevState) => ({
          distances: {
            ...prevState.distances,
            [polylineKey]: {
              distance: 'N/A',
              duration: 'N/A',
              polyline: 'N/A'
            },
          },
        }))
        this.getTableData()
      }
    } catch (error) {
      console.error('Error fetching distance:', error);
    }
  };


  calculateDistance2 = async () => {
    const { clickedMarkers } = this.state;
    // clickedMarkers = clickedMarkers.sort((a,b) => a.seq-b.seq)
    for (let i = 0; i < clickedMarkers.length; i++) {
      const lastMarker = clickedMarkers[i];
      const secondLastMarker = clickedMarkers[i - 1];

      if (!lastMarker || !secondLastMarker) continue;

      try {
        const response = await tripApi.create({
          origin: `${secondLastMarker.latitude},${secondLastMarker.longitude}`,
          destination: `${lastMarker.latitude},${lastMarker.longitude}`,
        });

        const polylineKey = `${secondLastMarker.station_id}-${lastMarker.station_id}`;

        if (response.status === 'OK') {
          const directions = response.routes[0];
          this.setState((prevState) => ({
            distances: {
              ...prevState.distances,
              [polylineKey]: {
                distance: directions.legs[0].distance.text,
                duration: directions.legs[0].duration.text,
                polyline: directions.overview_polyline.points,
              },
            },
          }))

        } else {
          this.setState((prevState) => ({
            distances: {
              ...prevState.distances,
              [polylineKey]: {
                distance: 'N/A',
                duration: 'N/A',
                polyline: 'N/A'
              },
            },
          }))
        }
      } catch (error) {
        console.error('Error fetching distance:', error);
      }
    }
    this.getTableData()
    this.state.clickCounts = []
    const newClickCounts = clickedMarkers.reduce((acc, item, index) => {
      acc[item.station_id] = index + 1
      return acc
    }, {})
    this.setState({ clickCounts: newClickCounts })
  };



  customMarker = ({ lat, lng, text, icon, data, isHovered, onHover }) => {
    const { workOrderStore, ticketStore } = this.props
    const clickCount = this.state.clickCounts[data.station_id];
    const distances = this.state.distances

    const workOrder = workOrderStore && workOrderStore.items && workOrderStore.items.reduce((latest, item) => {
      if (
        item.station &&
        Array.isArray(item.station) &&
        item.station.some(station => station.id == data.station_id) && item.archived !== true
      ) {
        return !latest || new Date(item.creation_date) > new Date(latest.creation_date) ? item : latest;
      }
      return latest;
    }, null);

    const ticket = ticketStore.items.reduce((latest, item) => {
      if (item.station_id === data.station_id && item.archived !== true) {
        if (!latest || new Date(item.generated_date) > new Date(latest.generated_date)) {
          return item;
        }
      }
      return latest;
    }, null);


    return (
      <div
        style={{
          position: 'relative',
          cursor: 'pointer',
          textAlign: 'center',
          borderRadius: '50%',
          boxShadow: clickCount
            ? '0 4px 10px rgba(0, 0, 0, 0.5)'
            : 'none',
        }}
        onMouseEnter={() => onHover(data.station_id, lat, lng)}
        onMouseLeave={() => onHover(null)}
        onClick={() => this.handleSingleClick(data.station_id, lat, lng, data.name)}
        onDoubleClick={() => this.handleDoubleClick(data.station_id)}
      >
        {clickCount ? (
          <div
            style={{
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f00',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 'bold',
              borderRadius: '50%',
              zIndex: 999,
              position: 'relative',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
            }}
          >
            {clickCount}
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: icon }} />
        )}

        {isHovered && (
          <div
            style={{
              position: 'absolute',
              bottom: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              padding: '10px',
              borderRadius: '5px',
              boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
              zIndex: 1000,
              whiteSpace: 'nowrap',
            }}
          >
            <table style={{ padding: '10px' }}>
              <tbody>
                <tr>
                  <th>Station Id:</th>
                  <td>{data.station_id}</td>
                </tr>
                <tr>
                  <th>Station:</th>
                  {/* <td>{data.name}</td> */}
                  <td>{data ? <Link to={`/station/${data.station_id}/maintenance`}>{data.name}</Link> : 'No Data'}</td>
                </tr>
                <tr>
                  <th>Ticket:</th>
                  <td>{ticket ? <Link to={`/monitoring/ticket/tabular/${ticket.id}/view`}>{ticket.summary || 'View'}</Link> : 'No Data'}</td>

                </tr>
                <tr>
                  <th>WorkOrder:</th>
                  <td>{workOrder ? <Link to={`/monitoring/work_order/tabular/${workOrder.id}/view`}>{workOrder.title || 'View'}</Link> : 'No Data'}</td>

                </tr>
                <tr>
                  <th>Distance:</th>
                  <td>
                    {distances[`${data.station_id}-${data.nextStationId}`] || '--'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };


  onClear = async () => {
    const { polylines } = this.state
    const { params: { id }, tripStore } = this.props
    for (const [key, value] of Object.entries(polylines)) {
      value.setMap(null)
    }

    this.setState({
      markers: [],
      markerIcons: [],
      mapCenter: null,
      selectedMarker: null,
      showPopUp: false,
      clickedMarker: null,
      clickCounts: {},
      nextCount: 1,
      clickedMarkers: [],
      distances: {},
      tableData: [],
      hasCalculatedDistance: false,
      insertData: true,
      isPreviousData: false,
      clickTimeOut: null,
      polylines: [],
      keysRemove: []
    })

    tripStore.updateStationData({
      station_id: '',
      duration: '',
      prevStationId: ''
    });
    await tripApi.deleteByTripId(id)
    await tripStore.fetchItems()
    await tripApi.deleteAllRoute(id)


  }

  onGoogleApiLoaded = ({ map, maps }) => {
    this.setState({ map, maps }, this.renderPolylines);
  };

  renderPolylines = () => {
    const { distances } = this.state;
    const { maps } = this.state;

    if (!distances || !maps) return;

    Object.entries(distances).forEach(([key, value]) => {
      if (!value) return;

      const decodedPath = maps.geometry.encoding.decodePath(value.polyline);

      const polylineOptions = {
        path: decodedPath,
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 3,
      };

      if (!this.state.polylines[key]) {
        const routePolyline = new maps.Polyline(polylineOptions);
        routePolyline.setMap(this.state.map);

        this.setState((prevState) => ({
          polylines: {
            ...prevState.polylines,
            [key]: routePolyline,
          },
        }));
      }
    });
  };

  render() {
    const { ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, stationStore, userStore, workOrderStore, tripStore, params: { id }, workOrderStatusStore, maintenanceTypeStore, priorityStore } = this.props;
    const { clickedMarkers } = this.state
    if (ticketStore.isLoading || stationStore.isLoading || userStore.isLoading || ticketStatusStore.isLoading || ticketActionStore.isLoading || ticketReasonStore.isLoading || workOrderStore.isLoading || workOrderStatusStore.isLoading || maintenanceTypeStore.isLoading || priorityStore.isLoading) return <Spinner />
    const { stationData } = tripStore
    const { maps, distances } = this.state

    let markers
    let markers2

    if (!ticketStore.assigned_to_all_trip) {
      const tickets = ticketStore.items.filter((item) => clickedMarkers.some((item2) => item.station_id == item2.station_id))
      const workOrders = workOrderStore.items.filter((item) => clickedMarkers.some((item2) => item.station && item.station.some((i) => i.id == item2.station_id)))
      markers = ticketStore.getMarkers2(tickets)
      markers2 = workOrderStore.getMarkers2(workOrders)
    } else {
      markers = ticketStatusStore.items.length > 0 && ticketReasonStore.items.length > 0 && ticketActionStore.items.length > 0
        ? ticketStore.getMarkers2()
        : [];

      markers2 = workOrderStatusStore.items.length > 0 && priorityStore.items.length > 0 && maintenanceTypeStore.items.length > 0
        ? workOrderStore.getMarkers2()
        : [];

    }

    const finalMarkers = Array.from(
      new Map([...markers, ...markers2].map(marker => [marker.station_id, marker])).values()
    );

    // const finalMarkers = Array.from(
    //   new Map([...markers].map(marker => [marker.station_id, marker])).values()
    // );

    const markerIcons = this.getFilteredMarkerIcons(markers);
    const markerIcons2 = this.getFilteredMarkerIcons2(markers2)


    const uniqueMarkerIcons = Array.from(
      new Map([...markerIcons, ...markerIcons2].map(icon => [icon.station_id, icon])).values()
    );

    // const uniqueMarkerIcons = Array.from(
    //   new Map([...markerIcons].map(icon => [icon.station_id, icon])).values()
    // );


    let resultMarkers = finalMarkers.map((item) => {
      const data = uniqueMarkerIcons.find((i) => i.station_id == item.id);
      return {
        ...item,
        ...data
      }
    })

    // console.log(resultMarkers,"result ko markersss");
    let mapCenter = getCenter(uniqueMarkerIcons)

    return (
      <div className='ticket-list-map' style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1, height: '600px', width: '50%' }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: 'AIzaSyAUr3hTNEKvSX3FPQgS0Ku77VZrCOx-G1M',
              libraries: ['geometry'],
            }}
            center={mapCenter}
            defaultZoom={7}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={this.onGoogleApiLoaded}
          >
            {resultMarkers.map((marker, index) => (
              <this.customMarker
                key={`${marker.station_id}-${index}`}
                lat={marker.latitude}
                lng={marker.longitude}
                text={marker.text}
                icon={marker.icon}
                data={marker}
                isHovered={this.state.selectedMarker == marker.station_id}
                onHover={this.handleHover}
              />
            ))}
          </GoogleMapReact>
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '10px' }}>
            <div className="button" style={{ padding: '4px', background: 'green' }} onClick={this.onClear}>Clear</div>
          </div>

          <div>
            <DataTable
              columns={[
                { key: "sn", label: "Sn" },
                { key: "id" },
                { key: "work_order", label: "Work Order" },
                { key: "station", label: "Station" },
                { key: "distance", label: "Distance" },
                { key: "duration", label: "Duration" },
              ]}
              data={this.state.tableData}
              slug={`monitoring/trip/map/${id}/view/stationadd/add`}
              allowAdd
              // allowEdit
              allowDelete
              onDelete={this.handleDelete}
              actions={[
                { label: 'Add', link: `/monitoring/trip/map/${id}/view/stationadd/add/{id}` },
              ]}
              inEvenRow
            />
            {this.props.children}
          </div>
        </div>


      </div>


    );
  }
}




export default TripMapTicketId


// WEBPACK FOOTER //
// ./src/components/Trips/TripMapTicketId.js